import commonState from '../commons/state'
import StretchFlow from '../../../models/stretch-flow'

const state = () => ({
  ...commonState,
  currentActivity: StretchFlow,
  updateActivity: StretchFlow,
})

export default state